/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Spanish (International)
export default {
  'project-panel.generic-error.description': 'Comprueba tu conexión a Internet e inténtalo de nuevo.',
  'project-panel.generic-error.title': 'Se ha producido un error',
  'project-panel.project-icon-header.update-error-description': 'No se ha podido actualizar el icono de {projectName}',
  'project-panel.project-icon-header.update-error-title': 'Algo ha ido mal.',
  'project-panel.project-panel-expand-field-button.show-less-collapsed-label': 'Mostrar más campos',
  'project-panel.project-panel-expand-field-button.show-more-collapsed-label': 'Mostrar menos',
  'project-panel.project-panel-header.title': 'Proyecto',
  'project-panel.project-panel-tabs.about-tab-title': 'Acerca de',
  'project-panel.project-panel-tabs.decisions-title': 'Decisiones',
  'project-panel.project-panel-tabs.learnings-title': 'Aprendizajes',
  'project-panel.project-panel-tabs.risks-title': 'Riesgos',
  'project-panel.project-panel-tabs.updates-tab-title': 'Actualizaciones',
  'project-panel.project-title.edit-button-label': 'Editar título del proyecto',
  'project-panel.project-title.update-error-description': 'No se ha podido actualizar el contenido de {projectName}',
  'project-panel.project-title.update-error-title': 'Se ha producido un error',
  'project-panel.project-title.validation-message': 'Introduce un título para tu proyecto',
};
